import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  setAgreedToTerms,
  setAuthenticated,
  setBuyer,
} from "../../../redux/slices/authSlice";
import { submitFullRegistration } from "./services/authServices";
import { showNotification } from "../../../redux/slices/notificationSlice";
import AuthCard from "../../../components/AuthCard";
import Button from "../../../components/Button";
export default function TermsAcceptance() {
  const [checked, setChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const requiredReason = t("pleaseCompleteRequiredFields", {
    defaultValue: "Please complete all required fields correctly.",
  });

  // ✅ Pull required data from Redux store
  const {
    email,
    password,
    firstName,
    lastName,
    mobile: phone,
  } = useSelector((state) => state.auth);

  const handleSubmit = async () => {
    if (!checked || isSubmitting) return;

    setIsSubmitting(true);
    try {
      dispatch(setAgreedToTerms(true));

      // ✅ Send full registration payload
      const { token, buyer } = await submitFullRegistration({
        email,
        password,
        firstName,
        lastName,
        phone,
        agreedToTerms: true,
      });
      localStorage.setItem("jwtToken", token);
      localStorage.setItem("buyer", JSON.stringify(buyer));
      dispatch(setBuyer(buyer));
      dispatch(setAuthenticated(true));
      dispatch(
        showNotification({ message: t('registrationComplete'), type: "success" })
      );
      navigate("/dashboard");
    } catch (err) {
      console.error("Registration failed", err);
      dispatch(
        showNotification({
          message: t('registrationFailed'),
          type: "error",
        })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 animate-fade-in">
      <AuthCard>
        <h2 className="sub-header mb-4">{t('termsAndConditions')}</h2>
        <p className="text-sm">
          {t('termsConsentInfo')}{' '}
          <a
            href="/legal/terms"
            className="text-red-600 underline"
            target="_blank"
            rel="noreferrer noopener"
          >
            Terms
          </a>{' '}·{' '}
          <a
            href="/legal/privacy"
            className="text-red-600 underline"
            target="_blank"
            rel="noreferrer noopener"
          >
            Privacy
          </a>
        </p>
        <div className="flex items-center my-6">
          <input
            id="accept-terms"
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className="mr-2"
            required
          />
          <label htmlFor="accept-terms" className="text-sm font-medium">
            {t('agreeTerms')}
            <span aria-hidden="true" className="ml-0.5 text-red-600">*</span>
            <span className="sr-only"> required</span>
          </label>
        </div>
        <Button
          onClick={handleSubmit}
          className="w-full"
          disabled={!checked || isSubmitting}
          disabledReason={!checked ? requiredReason : ""}
          loading={isSubmitting}
          loadingLabel={t("loading")}
        >
          {t('finish')}
        </Button>
      </AuthCard>
    </div>
  );
}
